// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { ReportGroupResponseMessage } from "../Messages/ReportGroupResponseMessage.js"
export let ReportGroupResponseMessageProcessor = function ()
{
    MessageProcessorBase.call(this)

    this.MsgArr = []
}

ReportGroupResponseMessageProcessor.prototype = Object.create(MessageProcessorBase.prototype)

ReportGroupResponseMessageProcessor.prototype.decode = function (fieldSet)
{
    let msg = new ReportGroupResponseMessage(fieldSet)

    this.MsgArr.push(msg)

    let responseEnd = fieldSet.GetField(FieldsFactory.FIELD_RESPONCE_END)
    if (responseEnd)
    {
        msg.RelatedMessages = this.MsgArr

        this.MsgArr = []
    }

    return responseEnd ? [msg] : []
}

